import { useEffect, useRef } from 'react'
import { projector } from '../data/radar'


/** Radar-backed canvas. Third place in this codebase that wanted one, so it lives here now.
 *  `paint` gets the context and a world→canvas projector; it's called once the radar has loaded
 *  (and immediately, so nothing waits on the network to show something). */
export function RadarCanvas({
  map,
  size = 640,
  maxWidth = 640,
  dim = 0.4,
  paint,
  deps = [],
}: {
  map: string
  size?: number
  maxWidth?: number
  /** The official radars are saturated enough to swallow marks — the map is context, not the subject. */
  dim?: number
  paint: (ctx: CanvasRenderingContext2D, project: (x: number, y: number) => [number, number]) => void
  deps?: unknown[]
}) {
  const ref = useRef<HTMLCanvasElement>(null)
  useEffect(() => {
    const cv = ref.current
    if (!cv) return
    const ctx = cv.getContext('2d')
    if (!ctx) return
    const project = projector(map, size)
    const radar = new Image()
    let dead = false

    const render = () => {
      if (dead) return
      ctx.clearRect(0, 0, size, size)
      ctx.fillStyle = 'rgba(10,12,16,1)'
      ctx.fillRect(0, 0, size, size)
      if (radar.complete && radar.naturalWidth) {
        ctx.save()
        ctx.globalAlpha = dim
        ctx.drawImage(radar, 0, 0, size, size)
        ctx.restore()
      }
      paint(ctx, project)
    }

    radar.onload = render
    radar.src = `/api/radar/${map}?v=cs2`
    render()
    return () => {
      dead = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, size, dim, ...deps])

  return (
    <canvas
      ref={ref}
      width={size}
      height={size}
      className="mx-auto block w-full border border-border"
      style={{ borderRadius: 'var(--radius)', maxWidth, aspectRatio: '1' }}
    />
  )
}
